
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { addressInfoType, contactInfoType, nameInfoType } from "@/types/Application/CommonInformation";
import { getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { lawyerInformationInfoDataInfoType, noticeLawyerPartyDataInfoType } from '@/types/Application/LawyerParty';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})

export default class Form42Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;     

    existingFileNumber = '';
    acknowledgeService = false; 
    lawyerInformation = {} as lawyerInformationInfoDataInfoType; 
    
    otherParties = '';
    allIssues = false;
    addressChanged = false;
    listOfIssues = [];    
    otherComment = '';    
    applicationAboutComment = '';
    courtDocumentsPreparationComment = '';
    specifiedIssuesComment = '';
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){        
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
        this.acknowledgeService = this.result.otherPartyNLPConfirmationSurvey?.confirmation == 'Confirmed';
        this.getNoticeLawyerPartyInfo();  
    } 

    public getNoticeLawyerPartyInfo(){  
        
        this.lawyerInformation = {} as lawyerInformationInfoDataInfoType;  
        this.otherParties = '';  
        
        this.allIssues = false;
        this.addressChanged = false;
        this.listOfIssues = [];   
        this.otherComment = '';    
        this.applicationAboutComment = '';
        this.courtDocumentsPreparationComment = '';
        this.specifiedIssuesComment = '';

        if(this.result?.noticeLawyerPartySurvey){

            let noticeLawyerParty = {} as noticeLawyerPartyDataInfoType;
            noticeLawyerParty = this.result.noticeLawyerPartySurvey; 

            this.getLawyerInformationResults(noticeLawyerParty);

            const otherParties = [];
            for (const otherParty of noticeLawyerParty.OtherPartyInfoNlp){
                otherParties.push(Vue.filter('getFullName')(otherParty.name))
            }      

            this.otherParties = otherParties.join(', ')        
            
            this.allIssues = noticeLawyerParty.RepresentingOnAllIssues == 'y';

            if (!this.allIssues){

                this.listOfIssues = noticeLawyerParty.IssuesList?.checked?noticeLawyerParty.IssuesList.checked:[];
                if (this.listOfIssues.includes("other")){
                    this.otherComment = noticeLawyerParty.IssuesList?.otherComment?noticeLawyerParty.IssuesList.otherComment:'';
                }      
                
                if (this.listOfIssues.includes("specifiedIssues")){
                    this.specifiedIssuesComment = noticeLawyerParty.IssuesList?.specifiedIssuesComment?noticeLawyerParty.IssuesList.specifiedIssuesComment:'';
                }  

                if (this.listOfIssues.includes("courtDocumentsPreparation")){
                    this.courtDocumentsPreparationComment = noticeLawyerParty.IssuesList?.courtDocumentsPreparationComment?noticeLawyerParty.IssuesList.courtDocumentsPreparationComment:'';
                }  

                if (this.listOfIssues.includes("applicationAbout")){
                    this.applicationAboutComment = noticeLawyerParty.IssuesList?.applicationAboutComment?noticeLawyerParty.IssuesList.applicationAboutComment:'';
                }  
            }
            
        }             
    }

    public getLawyerInformationResults(noticeLawyerParty: noticeLawyerPartyDataInfoType) {  
        
        if (noticeLawyerParty.AddressChanges && noticeLawyerParty.AddressChanges.includes('true')){
            this.addressChanged = false;
            this.lawyerInformation = {
                firmName: noticeLawyerParty.FirmName?noticeLawyerParty.FirmName:'',
                lawyerName: noticeLawyerParty.ApplicantName?noticeLawyerParty.ApplicantName:{} as nameInfoType,
                address: {} as addressInfoType,
                contact: {} as contactInfoType
            }
        } else {
            this.addressChanged = true;
            this.lawyerInformation = {
                firmName: noticeLawyerParty.FirmName?noticeLawyerParty.FirmName:'',
                lawyerName: noticeLawyerParty.ApplicantName?noticeLawyerParty.ApplicantName:{} as nameInfoType,
                address: noticeLawyerParty.LawyerAddressNlp?noticeLawyerParty.LawyerAddressNlp:{} as addressInfoType,
                contact: noticeLawyerParty.LawyerContact?noticeLawyerParty.LawyerContact:{} as contactInfoType
            }
        }

              
    }
 
}
